import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { AddProductionSiteFieldDefinitionToProducts } from "@tfg/types/schemas/modules/traceability/queries/add-production-site-field-definition-to-products.dto"

import { httpClient } from "~/backend/axios"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useAddProductionSiteFieldDefinitionToProductsMutation = (
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    AddProductionSiteFieldDefinitionToProducts
  >
) =>
  useMutation({
    mutationFn: async (body: AddProductionSiteFieldDefinitionToProducts) => {
      return await httpClient.put(
        `/admin/traceability/add-production-site-field-definition-to-products`,
        body
      )
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)

      showSuccessNotification({
        title: "Success",
        message: "Production field definition added to all products",
      })
    },
    onError: (error: AxiosError) => {
      showAxiosError({
        notificationTitle: "Error",
        notificationMessage: error.message,
        showNotification: true,
        error: error as Error,
      })
    },
  })
